import { AssetPackDetail, Box, LoadingSpinner, Typography } from '@components';
import { PackTemplate } from '@interfaces';
import { AssetsService } from '@services';
import { RootState } from '@stores';
import { ListComponent } from '@utils';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

interface props {
  groupId: string;
}

export const AssetPacksCointainer = ({ groupId }: props) => {
  const companyId = useSelector(
    (state: RootState) => state.companies.selectedCompany?.id
  );
  const [packs, setPacks] = useState<PackTemplate[]>();

  if (!companyId) {
    return 'error';
  }

  const assetService = new AssetsService();
  const fetchAssetPacks = async () => {
    const result = await assetService.getAssetPacksForGroup(
      companyId.toString(),
      groupId
    );
    setPacks(result.packs);
  };

  useEffect(() => {
    fetchAssetPacks();
  }, []);

  return (
    <>
      <Typography tag="h2" type="subtitle" addClass={'mb-4'}>
        Toegewezen packs
      </Typography>
      <Box size="smallest" type="noStyle" gridSize="grid-3">
        {packs ? (
          <ListComponent
            data={packs}
            renderItem={(item: PackTemplate) => <AssetPackDetail pack={item} />}
          />
        ) : (
          <LoadingSpinner />
        )}
      </Box>
    </>
  );
};

export default AssetPacksCointainer;
